import { Locale } from '@cars4ever/public-ui';

export interface IModelPricesConfig {
  isIncluded: boolean;
}

const modelPricesConfigMap: Record<Locale, IModelPricesConfig> = {
  [Locale.DK]: {
    isIncluded: false,
  },
  [Locale.SE]: {
    isIncluded: true,
  },
};

export default modelPricesConfigMap;
